import { combineReducers } from 'redux';
import shifts from './shifts';

export default combineReducers({ shifts });
